import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import tide from '../assets/images/Saudi_Tide_Tables.png';


function SaudiTideTables() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('Tide')}</h1>
        <img src={tide} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}><b>{t('Summary')}</b></p>
          <p style={{ textAlign: 'justify' }}><b>{t('​​​​​​​​​​​​​​​Type')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('Tide_​​​​​​​​​​​​​​​Type')}</p>
          
          <p style={{ textAlign: 'justify' }}><b>{t('Language')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('Tide_Language')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('Description')}</b></p>
        
          <p style={{ textAlign: 'justify' }}>{t('Tide_detailed_info1')}</p>
         
       
         
          <p style={{ textAlign: 'justify' }}><b>{t('Format')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('Tide_Format')}</p>
       
          
          <br/> <br/>
      
        <p  style={{ textAlign: 'justify' }}> {t('TideTable_RedSea')} <br/>
        <a href={t('Tide_URL1')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
      <br/> <br/>
       
        <p  style={{ textAlign: 'justify' }}> {t('TideTable_ArabianGolf')} <br/> 
        <a href={t('Tide_URL2')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
          
      </div> 
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default SaudiTideTables;
